import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";

import ViewAgradecimentoViagem from "../views/ViewAgradecimentoViagem";





const AgradecimentoViagem: React.FC = () => (
  <>
    <ContatoZap />
    <div>
      <ViewAppBar />

      <ViewAgradecimentoViagem/>
      

      <ViewFooter />
    </div>
  </>
);
export default AgradecimentoViagem;

